import React from 'react';
import { formatUsdAmount } from '../lib/formatUsd';
import { cn } from '../lib/utils';

type UsdPriceVariant = 'default' | 'onDark';

export function UsdPrice({
  value,
  variant = 'default',
  className,
  prefixClassName,
  amountClassName,
}: {
  value: number;
  variant?: UsdPriceVariant;
  className?: string;
  prefixClassName?: string;
  amountClassName?: string;
}): React.JSX.Element {
  const prefixToneClass =
    variant === 'onDark' ? 'text-white/70' : 'text-[var(--ir-muted)]';

  return (
    <span className={cn('inline-flex items-baseline gap-1.5', className)}>
      <span
        className={cn(
          // Scales with the amount, but never below the 12px text floor.
          'text-[length:max(0.58em,0.75rem)] font-normal leading-none tracking-normal',
          prefixToneClass,
          prefixClassName
        )}
      >
        US$
      </span>
      <span className={cn('font-bold leading-none', amountClassName)}>
        {formatUsdAmount(value)}
      </span>
    </span>
  );
}
